import React from "react"
import { Spinner } from "react-bootstrap"
import userApp from "../Shared/Controller/userApp"
import { GetRole } from "../common/CommonController";
import { Link } from "react-router-dom";
import * as Constants from "../partials/CommonConstant";
import NotFound from "../common/NotFound";
import ConfirmModal from "../common/ConfirmModal";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { connect } from "react-redux";

class Users extends userApp {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      resendEmailLoading: false,
      resendEmailUseIds: [],
      resendSuccessIds: [],
      userList: [],
      showModal: false,
      deletedUserId: "",
      showStatusModal: false,
      statusUserId: null,
      statusAction: null,
      page: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: "username",
      sortOrder: "asc",      
      searchText: "",
      userstatus: 1
    }
  }

  componentDidMount = () => {
    this.getUsers();
  }

  handlePageChange = (page) => {
    this.setState({ page }, this.getUsers);
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ perPage: newPerPage, page }, this.getUsers);
  };

  // handleSort = (column, sortDirection) => {
  //   const sortField = column.sortField || column.selector;  
  //   this.setState(
  //     {
  //       sortBy: sortField,
  //       sortOrder: sortDirection,
  //     },
  //     this.getUsers
  //   );
  // };

  handleSort = (column, sortDirection) => {
    const newSortBy = column.sortField || column.selector;
    
    this.setState((prevState) => ({
      sortBy: newSortBy,
      sortOrder: prevState.sortBy === newSortBy && prevState.sortOrder === "asc" ? "desc" : "asc",
      page: 1, // reset to first page
    }), this.getUsers);
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearchSubmit = () => {
    this.setState({ page: 1 }, this.getUsers);
  };

  clearSearch = () => {
    this.setState({ searchText: "", page: 1 }, this.getUsers);
  };

  render() {

    const {
      userList,
      loading,
      page,
      perPage,
      totalRows,
      searchText,
    } = this.state;

    // Create table headers consisting of 4 columns.
    const data = this.state.userList;
    const columns = [
      {
        name: "Username",
        selector: row => row.username,
        sortable: true,
        sortField: "username"
      },
      {
        name: "Name",
        selector: row => row.fullname,
        sortable: true,
        cell: d => { return d.fullname },
        sortField: "firstname"
      },
      {
        name: "Email",
        selector: row => row.email,
        sortable: true,
        sortField: "email"
      },
      {
        name: "Role",
        selector: row => row.role,
        sortable: true,
        cell: d => { return GetRole(d.role) },
        sortField: "role"
      },
      {
        name: "Status",
        selector: row => row.status,
        sortable: true,
        cell: d => { return this.getColumnData({ type: "status", item: d }) },
        sortField: "status"
      },
      {
        name: "Action",
        center: true,
        cell: d => { return this.getColumnData({ type: "action", item: d }) }
      }
    ];

    const tableData = {
      columns,
      data
    };

    return (
      <>
        <div className="dashboard-card-wrapper">
          <ConfirmModal show={this.state.showModal}
            onCloseModal={() => this.onCloseModal()}
            module="user"
            confirmClick={() => this.handleDelete()} />

          {/* NEW: status change confirm modal */}
          <ConfirmModal show={this.state.showStatusModal}
            onCloseModal={() => this.setState({ showStatusModal: false })}
            module="user"
            type={this.state.statusAction}
            confirmClick={() => this.handleChangeStatusConfirm()} />

          <div className="row align-items-center">
            <div className="col-12 text-end">
              <Link to={Constants.addUser} className="btn btn-blue btn-nex me-2">Add User</Link>
              {/* show Inactive Users button only to Admin (role === 1) */}
              {this.props.userDetail && Number(this.props.userDetail.role) === 1 && (
                <Link to={Constants.inactiveUsers} className="btn btn-blue btn-nex me-2">Inactive Users</Link>
              )}
              <Link to={Constants.deletedUsers} className="btn btn-blue btn-nex">Deleted User</Link>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 mt-3">
            <div className="card-main p-0">
              <div className="dark-table-wrapper table-scroll data-table">

                {/* Custom Search Input */}
                <div className="data-table-extensions d-flex align-items-center">

                    <div className="data-table-extensions-filter position-relative">

                      <label htmlFor="filterDataTable" className="icon"></label>                        
                      <input
                        type="text"
                        name= "filterDataTable"
                        className="filter-text w-100"
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => this.setState({ searchText: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ page: 1 }, this.getUsers);
                          }
                        }}                       
                      />
                      
                      {searchText && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            this.setState({ searchText: "", page: 1 }, this.getUsers);
                          }}
                          style={{
                            position: "absolute",
                            right: "13px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "23px",
                            color: "#545454"
                          }}
                          title="Clear search"
                        >
                        ×
                        </span>
                      )}

                    </div>
                    
                    <button
                      className="ms-2"
                      title="Click to Search"
                      disabled={searchText.trim() === ""}
                      style={{
                        backgroundColor: searchText.trim() === "" ? "#f4a75f" : "#ee7608", // lighter when disabled
                        color: "white",
                        border: "none",
                        padding: "8px 12px",
                        borderRadius: "50px",
                        cursor: searchText.trim() === "" ? "default" : "pointer"
                      }}
                      onClick={() => {
                        this.setState({ page: 1 }, this.getUsers);
                      }}
                    >
                      Search
                    </button>

                </div>

                {this.state.userList && this.state.userList.length !== 0 && this.state.loading === false &&                                  
                  <DataTable
                    columns={columns}
                    data={userList}                    
                    pagination
                    progressPending={loading}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    sortServer
                    onSort={this.handleSort}
                    highlightOnHover
                    pointerOnHover
                  />
                }
                {this.state.loading === true &&
                  <table className="mb-0 table">
                    <tbody>
                      <tr>
                        <td colSpan={10} className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                {/* Not found */}
                {this.state.loading === false && this.state.userList && this.state.userList.length === 0 &&
                  <NotFound message="No Data Found" type="content" />
                }

              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default connect(userApp.mapStateToProps)(Users);